import { date, object, string } from 'yup'

export const LoteActualizarValidationSchema = object({
  codigoLote: string().required('Ingrese el Código del Lote'),
  descripcion: string().required('Ingrese una Descripción'),
  fechaAdmision: date().required('Ingrese la Fecha de Admisión'),
  fechaFabricacion: date().required('Ingrese la Fecha de Fabricación'),
  fechaVencimiento: date().required('Ingrese la Fecha de Vencimiento'),
})
